import { useIsDarkMode } from '@/contexts/ThemeContext';

export function useCanvasColors() {
  const isDark = useIsDarkMode();
  return {
    roomFill: isDark ? '#535565' : '#FFFFFF',
    roomFillDetailed: isDark ? '#535565' : '#DADADC',
    roomStroke: isDark ? '#A8AAB8' : '#24252C',
    roomStrokeIdle: isDark ? '#6A6D81' : '#BEBECA',
    zoneStrokeIdle: isDark ? '#6A6D81' : '#CECEDA',
    textFill: isDark ? '#F9F9FA' : 'black',
    labelBg: isDark ? '#535565' : 'black',
    sensorLabelBg: isDark ? '#3C3D49' : undefined,
    hiveIconBg: isDark ? '#3C3D49' : 'white',
    canvasBg: isDark ? '#24252C' : '#fafafa',
    canvasBorder: isDark ? '#535565' : '#dddddd',
  };
}
